import React from "react";

import platinum from "../images/Platinum_Realty_Orange.jpg";

function Footer() {
  return (
    <footer className="bg-black">
      <nav className="flex max-w-6xl p-4 mx-auto text-sm md:px-4 md:py-4">
        <img src={platinum} alt="Platinum Realty Logo" className="md:h-24 h-12 object-fill" />
        <p className="text-white text-xs pl-8">
          Platinum Realty LLC<br/>
          9393 W. 110th St.  Suite 170<br/>
          Overland Park, KS 66210<br/>
          Main Office: <a href="tel:18882200988">1-888-220-0988</a>  -  Cell: <a href="tel:8168307575">816-830-7575</a><br/>
          <a href="mailto:JGo4th@aol.com">JGo4th@aol.com</a>
        </p>
      </nav>
    </footer>
  );
}

export default Footer;
